/* fail-safe */try{
/* Proactive Coaching — store interactions.
 *
 * ONE cart: the shop cart at shop.proactivecoaching.ai/cart. The Shopify Buy
 * Button SDK — and the separate floating cart it pinned to every page — was
 * removed 2026-08-03 (owner call). Its localStorage cart kept counting items
 * the real cart never saw, so the tab showed "30" beside a real cart of 1.
 * Every buy control is a plain link into the shop's GET /cart/add now
 * (build-store.py emits them); the header cart icon (default.hbs) is the one
 * cart affordance.
 *
 * The only JS the store still needs: the quick-add pills on the store grids.
 * Each pill sits INSIDE its card's <a> — a nested anchor would be invalid
 * HTML, so the pill is a <button data-pc-add="<variant id>"> and this
 * delegated handler turns the click into the same /cart/add navigation: the
 * item lands in the real cart, the buyer lands on the cart page (whose
 * "Continue shopping" points back at the store).
 */
(function () {
    document.addEventListener('click', function (e) {
        // The on-site cart (pc-cart.js) owns these clicks whenever a
        // storefront token is configured - it adds in place instead of
        // navigating. This legacy navigate-to-shop handler is the fallback
        // for the dormant state only.
        if (window.PCCart) return;
        var btn = e.target.closest && e.target.closest('[data-pc-add]');
        if (!btn) return;
        e.preventDefault();      // never let the click reach the card link
        e.stopPropagation();
        window.location.href = 'https://shop.proactivecoaching.ai/cart/add?id=' +
            encodeURIComponent(btn.getAttribute('data-pc-add')) + '&quantity=1';
    });
})();

}catch(e){/* stock Casper script assumes DOM our theme replaced; never halt the bundle */}
